import React, { useState, useEffect, useContext } from "react";
import FormButtons from "../../../revampComponents/Molecule/Buttons/FormButtons";
import LoadingSpinner from "../../../revampComponents/Atom/Loading";
import RichTextEditor from "../../../revampComponents/TipTapEditorNew/components/RichTextEditor";
import {  JS_TYPES, regexMethods } from "../../../reusable/common";
import { getCurrentEventId, scrollToError } from "../../../Utils/helpers";
import { CHAR_LIMITS, entityModule } from "../../EventInfo/config/constants";
import {
  DateTimePicker,
  RainbowThemeContainer,
} from "react-rainbow-components";
import TagsComponent from "../../../revampComponents/Atom/Tags/TagsComponent";
import TwoLabelSwitch from "../../../revampComponents/Atom/TwoLabelSwitch";
import Checkbox from "../../../revampComponents/Atom/Input/Checkbox";
import DropdownWithIcon from "./DropdownWithIcon";
import IconDateTime from "../../../../src/revampComponents/Atom/Icons/IconDateTime.svg";
import { uploadFile } from "../../../revampCRUD/uploads.crud";
import { getEventEntity } from "../../../revampCRUD/EventEntity.curd";
import { getCategoryEntity } from "../../../revampCRUD/categoryEntity.curd";
import { categoryEntity, convertToDateObj, convertToEventTimeZone, ENTITY_MODULES, eventId, FIELD_NAMES, formatDateWithTimeZone, getOptionLabel, handleError, hardcodedTimeZone, mapEntities, options, priorityOptions, SCREENS, stripHtmlTags, theme, TOGGLEMODE } from "./TaskManagementConstant";
import customToast from "../../../components/common/basic/Toast";
import UploadFiles from "./UploadFiles";
import { ErrMessages, SUCCESS_MESSAGES } from "../../EventInfo/config/error-constants";
import { useHistory, useParams } from "react-router-dom";
import Global from "../../../revampComponents/Atom/Global";

const AddNEditTask = ({ formik, predefinedTaskDetails, isPredefinedTask, isEdit, setIsEdit, setTaskDetails, taskDetails ,setEditCategoryIds,editCategorIds ,exhibitorId,setParticularExhibitorTask,particularExhibitorTask,entityCategoryId,eventDetails,setIsExhibitorToggle}) => {
  const history = useHistory();
  const [exhibitorData, setExhibitorData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tagsData, setTagsData] = useState([]);
  const [value, setValue] = useState("");
  const [openSelectTicketDropdown, setOpenSelectTicketDropdown] = useState(false);
  const [isChecked, setIsChecked] = useState([]);
  const [filterTags, setFilterTags] = useState(exhibitorData);
  const [exhibitorTags, setExhibitorTags] = useState([]);
  const [exhibitorChecked, setExhibitorChecked] = useState([]);
  const [categoryTags, setCategoryTags] = useState([]);
  const [categoryChecked, setCategoryChecked] = useState([]);

  const [toggleState, setToggleState] = useState({
    toggleMode: TOGGLEMODE.EXHIBITOR,
  });

  const eventEntityFunction = async (id) => {
    try {
      const result = await getEventEntity(id, entityModule.EXHIBITOR);
      if (result) {
        const allEntities = mapEntities(result.data.categorized, result.data.uncategorized);
        setExhibitorData(allEntities);
      }
    } catch (err) {
      handleError(err);
    }
  };
  const eventCategoryFunction = async (id) => {
    try {
      const result = await getCategoryEntity(id, categoryEntity.EXHIBITOR);
      if (result) {
        setCategoryData(result.data);
      }
    } catch (err) {
      handleError(err);
    }
  };

  const updateContent = (description) => {    
    formik.setFieldValue("description", description)
  };

  const updateAssigneeToggle = (key, value) => {
    setToggleState((prevState) => {
      const newState = { ...prevState, [key]: value };
  
      if (value === TOGGLEMODE.CATEGORY) {
        setExhibitorTags(tagsData);
        setExhibitorChecked(isChecked);
        setTagsData(categoryTags);
        setIsChecked(categoryChecked);
        setFilterTags(categoryData);
      } else {
        setCategoryTags(tagsData);
        setCategoryChecked(isChecked);
        setTagsData(exhibitorTags);
        setIsChecked(exhibitorChecked);
        setFilterTags(exhibitorData);
      }
  
      return newState;
    });
  };

  const handleDropdownChange = (fieldName, option) => {
    formik.setFieldValue(fieldName, option.value);
  };

  const deleteClickHandler = (e, filterTag) => {
    const updatedTags = tagsData.filter((tag) => tag.id !== filterTag.id);
    setTagsData(updatedTags);
    setIsChecked((prev) => prev.filter((id) => id !== filterTag.id));
  };

  const openDropDown = () => {
    setOpenSelectTicketDropdown(true);
  };

  const handleDateChange = (e, field) => {
    const newDate = formatDateWithTimeZone(e, hardcodedTimeZone);
    if (field === FIELD_NAMES.REMINDER_DATE) {
      formik.setFieldValue("reminder_date", newDate);
    } else {
      formik.setFieldValue("due_date", newDate);
    }
  };

  const handleChange = (e) => {
    const searchValue = e.target.value.toLowerCase(); 
    setValue(e.target.value);

    const filteredTags = (toggleState.toggleMode === TOGGLEMODE.EXHIBITOR
      ? exhibitorData
      : categoryData
    ).filter((tag) =>
      tag.category_name.toLowerCase().includes(searchValue) 
    );
    setFilterTags(filteredTags);
    setOpenSelectTicketDropdown(true);
  };  
  const getUploadedFiles = async (files) => {
    setLoading(true);
    try {
      if (files && files.length > 0) {
        const needsUpload = files.some(file => typeof file !== JS_TYPES.OBJECT || !file.url);
  
        const uploadedFiles = await Promise.all(
          files.map(async (file) => {
            if (file && typeof file === JS_TYPES.OBJECT && file.url) {
              return file; 
            } else {
              const uploadedUrl = await uploadFile(file, 20);
              return { file_name: file.name, url: uploadedUrl, file_type: file.type, file_size: file.size }; 
            }
          })
        );
  
        setLoading(false);
        formik.setFieldValue("files", [...uploadedFiles]);
  
        if (needsUpload) {
          customToast.success(SUCCESS_MESSAGES.FILE_MESSAGE);
        }
      }
    } catch (error) {
      customToast.error(ErrMessages.DEFAULT_ERROR_MESSAGE, error);
    }
  };  

  const isAllSelected =
    filterTags.length > 0 && isChecked.length - 1 === filterTags.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setIsChecked([]);
      setTagsData([]);
    } else {
      const sel = filterTags.map((tag) => tag.category_id)
      const sel2 = filterTags.map((tag) => ({
        id: tag.category_id,
        name: tag.category_name,
      }))
      setIsChecked([...sel, "all"]);
      setTagsData(sel2);
    }
  };

  const onValueSelect = (e, val) => {
    if (val.id === "all") {
      toggleSelectAll();
      return;
    }
    const isAlreadySelected = isChecked.includes(val.id);

    if (isAlreadySelected) {
      if (isChecked.includes("all")) {
        const updatedChecked = isChecked.filter((id) => id !== val.id && id !== "all");
        setIsChecked(updatedChecked);
        setTagsData(tagsData.filter((tag) => tag.id !== val.id));

      } else {
        const updatedChecked = isChecked.filter((id) => id !== val.id);
        setIsChecked([...updatedChecked]);
        setTagsData([...tagsData.filter((tag) => tag.id !== val.id)]);
      }

    } else {
      if (isChecked.length > 0 && isChecked.length === filterTags.length - 1) {
        setIsChecked([...isChecked, "all", val.id]);
        setTagsData([...tagsData, val]);
      } else {
        setIsChecked([...isChecked, val.id]);
        setTagsData([...tagsData, val]);
      }
    }
  };
  useEffect(() => {
    eventEntityFunction(eventId);
    eventCategoryFunction(eventId);
  }, []);
  const handleAutoAssignChange = (e) => {
    const isChecked = e.target.checked;
  
    if (isChecked) {
      const autoAssignType = toggleState.toggleMode === TOGGLEMODE.EXHIBITOR ? 1 : 2;
      formik.setFieldValue("auto_assign_type", autoAssignType);
    } else {
      formik.setFieldValue("auto_assign_type", null); 
    }
  };

  useEffect(() => {
    if (taskDetails.category_ids?.length > 0) {
      setToggleState({ toggleMode: TOGGLEMODE.CATEGORY });
      setTagsData(categoryTags);
      setIsChecked(categoryChecked);
      setFilterTags(categoryData);
    } else {
      setToggleState({ toggleMode: TOGGLEMODE.EXHIBITOR });
      setTagsData(exhibitorTags);
      setIsChecked(exhibitorChecked);
      setFilterTags(exhibitorData);
    }
  }, [taskDetails.category_ids, exhibitorData, categoryData]); 

  useEffect(() => {
    if ((!isEdit  && exhibitorId) ||(!isEdit && exhibitorId)   || (!isEdit && exhibitorId && entityCategoryId && particularExhibitorTask)) {
      const getFilteredData = (data, ids, key) => {
        const idsArray = Array.isArray(ids) ? ids.map(String) : [String(ids)];
        return data
          .filter(item => idsArray.includes(String(item[key])))
          .map(({ [key]: id, category_name: name }) => ({ id, name }));
      };
      const exhibitorIdsArray = Array.isArray(exhibitorId) ? exhibitorId.map(String) : [String(exhibitorId)];
      const transformedExhib = getFilteredData(exhibitorData, exhibitorIdsArray, 'category_id');
      const transformedCategory = getFilteredData(categoryData, entityCategoryId, 'category_id');
      if (toggleState.toggleMode === TOGGLEMODE.EXHIBITOR) {
        const currentexhibitorId = Number(exhibitorId);
        setIsChecked([...isChecked, currentexhibitorId]);
        setTagsData(transformedExhib);
      } else {
        setIsChecked([...isChecked]);
        setTagsData([]);
      }
    }
  }, [isEdit, exhibitorData, particularExhibitorTask, isPredefinedTask, exhibitorId, categoryData, toggleState.toggleMode, entityCategoryId]);

  useEffect(() => {
    if (isPredefinedTask) {
      formik.setFieldValue("title", predefinedTaskDetails.module_name);
      formik.setFieldValue("task_type", predefinedTaskDetails.task_type);
    }
  }, [isPredefinedTask, predefinedTaskDetails, isEdit]);
  useEffect(() => {
    if (!isEdit) return;
  
    const transformCategoryData = (data, categoryIds) => 
      data
        .filter(item => categoryIds.includes(String(item.category_id)))
        .map(({ category_id: id, category_name: name }) => ({ id, name }));
  
    const getAllIds = (data) => data.map(({ id }) => id);
    const getIdAndName = (data) => data.map(({ id, entity_name: name }) => ({ id, name }));
  
    const editExhibitorData = formik?.values?.exhibitors || [];
    const category = transformCategoryData(categoryData, formik?.values?.category_ids);
  
    if (toggleState.toggleMode === TOGGLEMODE.EXHIBITOR) {
      setFilterTags(exhibitorData);
      if (exhibitorData.length === editExhibitorData.length) {
        setIsChecked([...getAllIds(editExhibitorData), 'all']);
        setTagsData(getIdAndName(editExhibitorData));
      } else {
        setIsChecked(getAllIds(editExhibitorData));
        setTagsData(getIdAndName(editExhibitorData));
      }

    } else {
      setFilterTags(categoryData);
      if (category.length === categoryData.length) {
        setIsChecked([...getAllIds(category), 'all']);
        setTagsData(category);

      } else {
        setIsChecked(getAllIds(category));
        setTagsData(category);
      }

    }
  }, [isEdit,exhibitorData, categoryData, taskDetails.category_ids, toggleState.toggleMode]);

  useEffect(() => {
    const selectedIds = tagsData
      .filter((item) => item.id !== 'all')
      .map((item) => `${item.id}`);
      if (toggleState.toggleMode === TOGGLEMODE.EXHIBITOR) {
        formik.setFieldValue("exhibitor_ids", selectedIds);
        setIsExhibitorToggle(true);
      } else if (toggleState.toggleMode === TOGGLEMODE.CATEGORY) {
        formik.setFieldValue("category_ids", selectedIds);
        setIsExhibitorToggle(false);
      }  
  },
    [tagsData,isEdit, toggleState.toggleMode , taskDetails.category_ids, taskDetails.exhibitor_ids]);
  const enhancedFilterTags = [
    ...(categoryData.length > 0 && filterTags.find((tag) => tag.id !== "all") ? [{ id: "all", name: "All" }] : []),
    ...filterTags.map((tag) => ({
      id: tag.category_id,
      name: tag.category_name,
    }))
  ];
  return (
    <>
      {formik.values && Object.keys(formik.values).length !== 0 ? (
        <div className="px-4 pt-2">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-12 col-md-12 pt-1">
                <div>
                  <label htmlFor="task_title" className="label task-input-label mt-2">
                    Task Title <span className="text-danger"> *</span>
                  </label>
                </div>
                <div>
                  <input
                    id="title"
                    name="title"
                    placeholder="Enter task title"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.title}
                    disabled={isPredefinedTask} 
                    className={
                      formik.errors.title && formik.touched.title
                        ? "input border-danger box-shawdow-none"
                        : "input task-input-label"
                    }
                  />
                  {formik.errors.title && formik.touched.title && (
                    <p className="text-danger mt-2">{formik.errors.title}</p>
                  )}
                </div>
              </div>

              <div className="col-12 col-md-6 pt-1 mt-2">
                <div>
                  <label htmlFor="task_type" className="label mt-2">
                    Task Type <span className="text-danger"> *</span>
                  </label>
                </div>
                <div>
                  <DropdownWithIcon
                    value={options.find(
                      (option) => option.value === formik.values.task_type,
                    )}
                    options={options}
                    onChange={(option) =>
                      handleDropdownChange("task_type", option)
                    }
                    onBlur={() => formik.setFieldTouched("task_type", true)}
                    getOptionLabel={getOptionLabel}
                    disabled={isPredefinedTask || isEdit} 
                    className={`task-dropdown ${isPredefinedTask || isEdit ? "task-dropdown-disabled" : ""}`}
                  />
                  {formik.errors.task_type && formik.touched.task_type && (
                    <p className="text-danger mt-2">{formik.errors.task_type}</p>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 pt-1 mt-2">
                <div>
                  <label htmlFor="priority" className="label mt-2">
                    Priority
                  </label>
                </div>
                <div>
                  <DropdownWithIcon
                    value={priorityOptions.find(
                      (option) => option.value === formik.values.priority,
                    )}
                    options={priorityOptions}
                    onChange={(option) =>
                      handleDropdownChange("priority", option)
                    }
                    onBlur={() => formik.setFieldTouched("priority", true)}
                    getOptionLabel={getOptionLabel}
                  />

                  {formik.errors.priority && formik.touched.priority && (
                    <p className="text-danger mt-2">{formik.errors.priority}</p>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-12 pt-1 mt-2">
                <div>
                  <label htmlFor="description" className="label mt-2">
                    Task Description
                  </label>
                </div>
                <div>

                  <RichTextEditor
                    content={formik.values.description}
                    onChangeContent={updateContent}
                    placeholder="Enter your description here"
                    showTextFormatters
                    showTextHighlighters
                    showHistory
                    showTextAligners
                    showLists
                    showTable
                    showImage
                    showVideo
                    showBlockQuote
                    showHr
                    showLink
                    showSlashCommand
                  />
                  <div className="d-flex justify-content-between">
                    <p className="text-danger mt-2 pt-1 mb-0">
                      {formik.errors.description &&
                        formik.touched.description && (
                          <p>{formik.errors.description}</p>
                        )}
                    </p>
                    <p className="maxCharForInput">
                      Maximum Characters: {CHAR_LIMITS.taskDescription.descMax}
                    </p>
                  </div>
                </div>
              </div>
              <UploadFiles isEdit={isEdit} formik={formik} getUploadedFiles={getUploadedFiles} loading={loading} />
              <div className="d-flex mt-2 align-items-start justify-content-between col-12 task-form-input-title  pt-1 task-time-container">
                <div
                  className="d-flex flex-column"
                  style={{ maxWidth: "640px" }}
                >
                  <p className="task-form-input-title">Reminder Date</p>
                  <p className="task-form-input-subtitle">
                    Set a reminder date for the task. A notification will be
                    sent to exhibitors on this date.
                  </p>
                </div>
                <div>
                <div className="text-right timezone-task-text"><Global timeZone={eventDetails?.time_zone} /></div>

                  <div className="dateTimeInput w-100">
                    <RainbowThemeContainer
                      theme={theme}
                      className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                    >
                      <DateTimePicker
                        id="reminder_date"
                        name="reminder_date"
                        locale="en-IN"
                        className={
                          formik.errors["reminder_date"] &&
                            formik.touched.reminder_date
                            ? "calendarCus border-danger box-shawdow-none "
                            : "calendarCus "
                        }
                        value={
                           convertToDateObj(formik.values.reminder_date) 
                        }
                        hideLabel={true}
                        okLabel="Save"
                        label="DateTimePicker label"
                        formatStyle="medium"
                        minDate={new Date()}
                        icon={<img src={IconDateTime} />}
                        onChange={(e) => handleDateChange(e, "reminder_date")}  
                      />
                    </RainbowThemeContainer>
                    {formik.errors.reminder_date && (
                      <p className="text-danger mt-2">
                        {formik.errors.reminder_date}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex mt-2 align-items-start justify-content-between col-12 task-form-input-title task-time-container pt-1">
                <div
                  className="d-flex flex-column"
                  style={{ maxWidth: "610px" }}
                >
                  <p className="task-form-input-title">Due Date</p>
                  <p className="task-form-input-subtitle">
                    Set a due date for the task. A reminder will be
                    automatically sent to exhibitors 24 hours before the
                    deadline.
                  </p>
                </div>
                <div>
                <div className="text-right timezone-task-text"><Global timeZone={eventDetails?.time_zone} /></div>
                  <div className="dateTimeInput w-100">
                    <RainbowThemeContainer
                      theme={theme}
                      className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                    >
                      <DateTimePicker
                        id="due_date"
                        name="due_date"
                        locale="en-IN"
                        className={
                          formik.errors["due_date"] &&
                            formik.touched.due_date
                            ? "calendarCus border-danger box-shawdow-none "
                            : "calendarCus "
                        }
                        value={
                           convertToDateObj(formik.values.due_date) 
                        }
                        hideLabel={true}
                        okLabel="Save"
                        label="DateTimePicker label"
                        formatStyle="medium"
                        minDate={new Date()}
                        icon={<img src={IconDateTime} />}
                        onChange={(e) => handleDateChange(e, "due_date")} 
                      />
                    </RainbowThemeContainer>
                    {formik.errors.due_date && (
                      <p className="text-danger mt-2">
                        {formik.errors.due_date}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 pt-1 mt-2">
                <div className="d-flex align-items-center">
                  <span className="label manual-label-text task-form-checkbox-title">
                    Assign to Exhibitors
                  </span>
                  <div className="">
                    <TwoLabelSwitch
                      value={toggleState.toggleMode === TOGGLEMODE.EXHIBITOR} 
                      onChangeSwitch={(value) => {
                        const newMode = value
                          ? TOGGLEMODE.CATEGORY
                          : TOGGLEMODE.EXHIBITOR; 
                        updateAssigneeToggle("toggleMode", newMode);
                      }}
                    />
                  </div>
                  <span className="label task-form-checkbox-title">Assign to Categories</span>
                </div>
                <TagsComponent
                  addMultipleTagsButton={false}
                  placeholder={toggleState.toggleMode === 'exhibitor'
                    ? "Search by typing an exhibitor name"
                    : "Search by typing a category name"
                  }
                  noDataText={
                      toggleState.toggleMode === 'exhibitor'
                        ? (tagsData.length === 0 || filterTags.length === 0
                          ? "No Exhibitors found"
                          : "")
                        : (categoryData.length === 0
                          ? "No Categories found"
                          : "")
                    }
                  tagsData={tagsData}
                  dragEnd={null}
                  editIcon={false}
                  deleteIcon={true}
                  deleteClickHandler={deleteClickHandler}
                  isDragDisabled={true}
                  value={value}
                  handleChange={handleChange}
                  CheckboxDropdownData={enhancedFilterTags} 
                  onValueSelect={onValueSelect}
                  openSelectTicketDropdown={openSelectTicketDropdown}
                  setOpenSelectTicketDropdown={setOpenSelectTicketDropdown}
                  isChecked={isChecked} 
                  setValue={setValue}
                  setTagsData={setFilterTags}
                  addNewValueinDropDown={false}
                  openDropDown={openDropDown}
                  isSelectInclude={true}
                  showNoDataMessage={false}
                />
                <div></div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-4">
                            <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-center aligns-items-center">
                            <Checkbox
                  labelClassName="checkboxCard-label ml-1"
                  checked={formik.values.auto_assign_type === (toggleState.toggleMode === TOGGLEMODE.EXHIBITOR ? 1 : 2)}
                    onChange={handleAutoAssignChange}
                />
            <span className="label task-form-input-title pr-2">
              {`Auto Assign to Future ${
                toggleState.toggleMode === TOGGLEMODE.EXHIBITOR
                  ? "Exhibitors"
                  : "Exhibitors of the Selected Categories"
              }`}
            </span>
          </div>             
                  </div>
                </div>
            <div className="mt-2 loadingCenter ">
              <FormButtons
                isLoading={loading || formik.isSubmitting}
                formik={formik}
                onSave={() => {
                  scrollToError(formik); 
                  formik.submitForm();
                }}
                onCancel={() => {
                      formik.handleReset();
                      history.push(exhibitorId
                        ? `/e/${eventId}/exhibitor-portal/${exhibitorId}/tasks`
                        : `/e/${eventId}/exhibitor-portal/task-management`);
                    }}
                saveBtnContent="Save"
                // cancelBtnDisabled={!formik.dirty}
                saveBtnDisabled={loading || !formik.dirty || formik.isSubmitting}
                />
            </div>
          </form>
        </div>
      ) : (
        <LoadingSpinner />
      )}
      <style>{`
		.task-upload-container {
			width: 100%;
		}
    .timezone-task-text{
     color: var(--primaryColor) !important;
     font-size:11px ;
    }
     .task-form-input-title{
           color: var(--primaryColor) !important;
           margin-bottom: 5px;
    }
     .task-form-checkbox-title{
           color: var(--primaryColor) !important;
    }
       .task-form-input-subtitle{
           color:#333333;
            font-size:14px;
            font-weight:400;
     }
     .checkboxCard-label{
          margin-top:5px;
     }
      .task-input-label:disabled, task-input-label {
        background-color: #F2F2F2 !important;
      }
      .task-time-container .dateTimeInput {
        min-width: 184px;
      }
	`}</style>
    </>
  );
};

export default AddNEditTask;
